/**
 * Values of the `spellCorrection` search URL param. `Off` marks the "Search instead for" link, which
 * must show the literal results for what the person typed instead of correcting it again.
 */
export enum SpellCorrectionUrlValue {
    Off = 'off',
}
